import { useEffect } from "react";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import { WhatsAppWidget } from "./WhatsAppWidget";
import { BookCall } from "./BookCall";
import { Reveal, Eyebrow } from "./Reveal";

export const PageShell = ({ eyebrow, title, accent, sub, testid, children }) => {
    useEffect(() => {
        document.title = `${eyebrow}, Syntera Technologies`;
    }, [eyebrow]);

    return (
        <div className="bg-ink text-slate-100" data-testid={testid}>
            <Navbar />
            <section className="grain relative overflow-hidden border-b border-white/[0.06] pb-16 pt-40 sm:pb-24">
                <div className="pointer-events-none absolute -left-40 top-0 h-[380px] w-[380px] rounded-full bg-volt/10 blur-[140px]" />
                <div className="pointer-events-none absolute -right-32 bottom-0 h-[300px] w-[300px] rounded-full bg-blue-600/10 blur-[130px]" />
                <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
                    <Reveal>
                        <Eyebrow>{eyebrow}</Eyebrow>
                        <h1 className="max-w-3xl font-syne text-4xl font-extrabold leading-[1.08] tracking-tight text-white sm:text-5xl" data-testid={`${testid}-title`}>
                            {title}{" "}
                            <span className="text-glow bg-gradient-to-r from-volt to-blue-500 bg-clip-text text-transparent">
                                {accent}
                            </span>
                        </h1>
                        <p className="mt-5 max-w-2xl text-base leading-relaxed text-slate-400 sm:text-lg" data-testid={`${testid}-sub`}>
                            {sub}
                        </p>
                    </Reveal>
                </div>
            </section>
            <main>{children}</main>
            <BookCall />
            <Footer />
            <WhatsAppWidget />
        </div>
    );
};
